import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import SearchIcon from "~/assets/icons/SearchIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { Drawer } from "../Drawer.client"
import Navigation from "../navigation/Navigation.client"
import { MenuItem } from "~/types"
import { contactInfo } from "../../../../setup/settings/index"
import WishButtonIcon from "../../../../setup/custom_icons/WishButtonIcon"
import { wishlistButtonNextTitle, routeWishList } from "../../../../setup/settings/__product"
import TikTokIcon from "~/assets/icons/TikTokIcon"

type MenuDrawerProps = {
    isOpen: boolean,
    onClose: () => void,
    showCategory: string | boolean,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    storeName: string,
    menuItems: MenuItem[],
    shopSettings: any
}

export default function MenuDrawer({ isOpen, onClose, showCategory, setShowCategory, goTo, storeName, menuItems, shopSettings }: MenuDrawerProps) {
    return (
        <Drawer open={isOpen} onClose={onClose} openFrom="left" heading={storeName} hideLogo={true}>
            <div className="grid">
                <nav className="grid gap-4 p-6 sm:gap-6 sm:px-12 sm:py-8">

                    <div className="topUserAreaResponsive open loginCart basis-3/12 text-right mb-10">
                        <div className="topUserAreaResponsive__search-container">
                            <div className="topUserAreaResponsive__search">
                                <form action={`/products`} method="GET">
                                    <input name="search" type="search" placeholder="Search..." />
                                    <i className="fa fa-search">
                                        <button type='submit' className='buttonSearch'>
                                            <SearchIcon />
                                        </button>
                                    </i>
                                </form>
                            </div>
                        </div>
                    </div>

                    <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} onClose={onClose} mobile shopSettings={shopSettings} />
                    <div className="wishListResonsive">
                        {wishlistButtonNextTitle &&
                            <div className="topUserArea__login">
                                <a href={routeWishList}><WishButtonIcon />Wishlist</a>
                            </div>
                        }
                    </div>
                    <div className="iconsInformation">
                        <a className="iconsInformation__call" href={`tel:${contactInfo?.phone}`}><i><PhoneHeader /></i>Call {contactInfo?.phone}</a>
                        <a className="iconsInformation__email" href={`mailto:${contactInfo?.mailTo}`}><i><MailHeader /></i>Email us</a>
                        <a className="iconsInformation__visit" href={contactInfo?.page}><i><VisitHeader /></i>Visit us</a>
                    </div>

                    <div className="responsiveMenu__socialIcons">
                        {contactInfo?.facebook && <a href={contactInfo?.facebook}><FacebookIcon /></a>}
                        {contactInfo?.instagram && <a href={contactInfo?.instagram}><InstagramIcon /></a>}
                        {contactInfo?.twitter && <a href={contactInfo?.twitter}><TwitterIcon /></a>}
                        {contactInfo?.pinterest && <a href={contactInfo?.pinterest}><PinterestIcon /></a>}
                        {contactInfo?.youtube && <a href={contactInfo?.youtube}><YoutubeIcon /></a>}
                        {contactInfo?.linkedin && <a href={contactInfo?.linkedin}><LinkedinIcon /></a>}
                        {contactInfo?.tiktok && <a href={contactInfo?.tiktok}><TikTokIcon /></a>}
                    </div>

                </nav>

            </div>
        </Drawer>
    )
}